import { useCallback, useEffect, useState } from "react";
import styled from 'styled-components';
import { notification } from 'antd';
import { Chart } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  BarController,
  LineController,
} from "chart.js";

// services
import * as DashboardService from "../../../../services/bb-api/dashboards";

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  BarController,
  LineController,
  Legend,
  Tooltip
);

type Props = {
  country?: number,
  yAxisMax?: number,
  yAxisStepSize?: number
}

export const TotalUsersDiagram: React.FC<Props> = ({ country, yAxisMax = 2500, yAxisStepSize = 250 }) => {
  const [userData, setUserData] = useState<number[]>([]);

  const getData = useCallback(() => {
		try {
      DashboardService.weeklyUserCount(country).then(setUserData)
		} catch (error) {
			const message = 'Der skete en fejl';
			notification.error({ message });
		}
  }, [])
  
	useEffect(() => {
		getData();
		const intervalTime = 60 * 1000 // 1 min
		const intervalId = setInterval(getData, intervalTime)
		return () => clearInterval(intervalId)
  }, [getData]);
  
  function generateLabels(numberOfWeeks: number): Array<number> {
    let weekLabels: Array<number> = [];
	let startWeek = 1
    for (startWeek; startWeek <= numberOfWeeks; startWeek++) {
      weekLabels.push(startWeek);
    }
    return weekLabels;
  }


  const chartData = {
    labels: generateLabels(26),
    datasets: [
      {
        data: userData,
        backgroundColor: '#6675cd',
        borderColor: '#6675cd',
        borderRadius: 6,
        // borderSkipped: false,
      },
    ],
  };

  const chartOptions: Record<string, any> = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        display: true,
        position: 'left',
        min: 0,
        max: yAxisMax,
        ticks: {
          stepSize: yAxisStepSize,
          font: {
            size: 18,
          },
          autoSkip: true,
          maxTicksLimit: 11,
        },
        grid: {
          color: "#9CA3AF",
          drawBorder: false
        },
      },
      x: {
        grid: {
          display: false
        },
      }
    },
    maintainAspectRatio: false,
  };

  return (
    <StyledContainer className="diagram-container">
      <div className="diagram">
        <Chart
          type='bar'
          data={chartData}
          options={chartOptions}
        />
      </div>
    </StyledContainer>
  );
}

const StyledContainer = styled.div`
  margin: 1em;

  .diagram {
    width: 100%;
    height: 100%;
    box-shadow: rgba(0,0,0,0.2) 0px 2px 8px 0px;
    background-color: #1f2937;
    border-radius: 0.5em;
    padding: 2em;
  }
`
